
const routes = [
  {
    path: '/my-info-edit',
    redirect: { name: 'MyInfoEditList' },
    meta: { layout: 'default' },
    children: [
      {
        path: 'detail',
        name: 'MyInfoEditDetail',
        meta: { layout: 'default', menu: 'my-info-edit', requiresAuth: true },
        component: () => import('@/pages/myInfoEdit/myInfoEditView.vue'),
        props: true
      }
    ]
  }
]

export default routes

